import { render } from "./ApprovePerson.vue?vue&type=template&id=104b61f1&scoped=true"
import script from "./ApprovePerson.vue?vue&type=script&lang=js"
export * from "./ApprovePerson.vue?vue&type=script&lang=js"

import "./ApprovePerson.vue?vue&type=style&index=0&id=104b61f1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-104b61f1"

export default script